import React from "react";

import AddIcon from "@mui/icons-material/Add";
import SettingsIcon from "@mui/icons-material/Settings";

import styles from "./MenuItem.module.css";

interface Props {
  text: string;
  icon: "Add" | "Gear" | React.ReactNode;
  onClick: () => void;
}

const DropdownMenuActionItem: React.FC<Props> = ({
  text,
  icon,
  onClick,
}: Props) => {
  return (
    <div className={styles.container} onClick={onClick}>
      <div className={styles.left}>
        {icon === "Add" ? (
          <AddIcon className={styles.icon} />
        ) : icon === "Gear" ? (
          <SettingsIcon className={styles.icon} />
        ) : (
          icon
        )}

        <div className={styles.text}>{text}</div>
      </div>
    </div>
  );
};

export default DropdownMenuActionItem;
